import { render, staticRenderFns } from "./CotacaoFreteVolumes.vue?vue&type=template&id=5687ca66"
import script from "./CotacaoFreteVolumes.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteVolumes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports